import { createAction, props } from '@ngrx/store';
import { PushNotificationSchema } from '@capacitor/push-notifications';
import { AppDeepLink } from '@qvs/core';

export const ready = createAction('[App] ready');

export const resume = createAction('[App] resume');

export const pause = createAction('[App] pause');

export const error = createAction('[App] error');

export const keyboardIsOpen = createAction('[App] keyboard is open', props<{ height: number }>());

export const keyboardWillOpen = createAction('[App] keyboard will open', props<{ height: number }>());

export const keyboardWillClose = createAction('[App] keyboard will close', props<{ height: number }>());

export const keyboardIsClosed = createAction('[App] keyboard is closed', props<{ height: number }>());

export const loadPersistedStateSuccess = createAction('[App] load persisted state success');

export const backendAvailableOrHasChanged = createAction('[App] Backend is available or has changed');

export const newsConfigurationHasChanged = createAction('[App] News configuration has changed');

export const appStartedByPushNotificationClick = createAction(
  '[App] App Started By Push Notification Click',
  props<{ pushNotification: PushNotificationSchema; actionId: string }>()
);

export const resetAppStartedByDeepLinkClick = createAction('[App] Reset App Started By Deep Link Click');

export const appStartedByDeepLinkClick = createAction('[App] App Started By Deep Link Click', props<{ deepLink: AppDeepLink }>());

export const hideTabs = createAction('[App] Hide Tabs');

export const unHideTabs = createAction('[App] Un Hide Tabs');
